<template>
  <attendance-list-raw
    :course-id="courseId"
    :lesson-id="lessonId"
    :event-id="eventId"
    :registration-enabled="registrationEnabled"
    :enable-type="enableType"
    :close-key-available="closeKeyAvailable"
    :confirm-available="confirmAvailable"
    :is-loading="isLoading"
    :disabled-by-select-all="disabledBySelectAll"
    :use-on-smart-board="useOnSmartBoard"
    :create-new-student="createNewStudent"
    @selectAllStudents="selectAllStudents"
    @echoAttendances="echoAttendances"
    @changedRegisteredState="changeRegisteredState"
    @startTour="tourStarted"
    @closeKey="closeKey"
    @confirmAttendances="confirmAttendances"
  />
</template>

<script>

import AttendanceListRaw from './AttendanceListRaw.vue'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'AttendanceList',

  components: { AttendanceListRaw },

  props: {
    closeKeyAvailable: {
      required: false,
      default: false,
    },
    confirmAvailable: {
      required: false,
      default: false,
    },
    courseId: {
      required: true,
      type: String,
    },
    lessonId: {
      required: true,
      type: String,
    },
    eventId: {
      required: true,
      type: String,
    },
    registrationEnabled: {
      default: false,
    },
    useOnSmartBoard: {
      required: false,
      default: false,
    },
    createNewStudent: {
      required: false,
      default: true,
    },
  },

  data () {
    return {
      disabledBySelectAll: false,
      echo: null,
      enableType: 'single',
      isLoading: true,
      tour: 'AttendanceListTour',
    }
  },

  mounted () {
    this.$store.dispatch('change_loading', { loading: false })
      .then(() => this.$store.dispatch('set_course_and_lesson', { courseId: this.courseId, lessonId: this.lessonId, registrationEnabled: this.registrationEnabled }))
      .then(() => this.$store.dispatch('get_lesson_data'))
      .then(() => this.$store.dispatch('set_context_labels'))
      .then(() => this.$store.dispatch('set_minutes_missing_config'))
      .then(() => this.$store.dispatch('get_student_data'))
      .then(() => this.$store.dispatch('get_attendance_data'))
      .finally(() => {
        this.isLoading = false

        this.setupTour()
      }).catch(error => defaultErrorMessage(error))
  },

  methods: {
    setupTour () {
      axios.get('/tour/check', { params: { tour: this.tour } }).then((response) => {
        if (!response.data.watched) {
          this.tourStarted()
        }
      }).catch(error => defaultErrorMessage(error))
    },

    tourStarted () {
      axios.post('/tour/start', { tour: this.tour }).then(() => {
        this.$tours[this.tour].start()
      }).catch(error => defaultErrorMessage(error))
    },
    selectAllStudents (event) {
      this.$store.dispatch('change_loading', { loading: true }).then(() => {
        this.disabledBySelectAll = true

        if (event.allSelected) {
          $('.student_checkbox').each(function () {
            this.checked = false
          })
        } else {
          $('.student_checkbox').each(function () {
            this.checked = true
          })
        }
        return this.$store.dispatch('change_attendance', {
          courseId: this.courseId,
          lessonId: this.lessonId,
          studentIds: Object.keys(this.$store.state.attendancelist.students),
          attended: event.allSelected,
          unexpected: false,
        }).catch(error => defaultErrorMessage(error))
      }).then(() => {
        this.disabledBySelectAll = false
        this.$store.dispatch('change_loading', { loading: false })
      })
    },

    echoAttendances (event) {
      this.$store.dispatch('echo_attendances', { studentIds: event.changedStudentIds }).catch(error => defaultErrorMessage(error))
    },

    changeRegisteredState () {
      axios.put('attendance-list/set-unregistered').catch(error => defaultErrorMessage(error))
    },
    closeKey () {
      this.$store.dispatch('close_key').catch(error => defaultErrorMessage(error))
    },
    confirmAttendances () {
      this.$store.dispatch('confirm_attendances').catch(error => defaultErrorMessage(error))
    },
  },
}
</script>

<style>
    .attendance-list-container {
        flex: 0 1 auto;
        display: flex;
        flex-direction: column;
        height: inherit;
    }

    .attendance-list-footer {
        display: flex;
        flex: 0 0 50px;
        flex-wrap: wrap;
        width: inherit;
        padding-right: 13px;
        padding-left: 13px;
        padding-top: 8px;
        background-color: #25167a;
        z-index: 999;
    }

    .attendance-exclamation {
        height: 60px;
        width: inherit;
        background-color: #EEEEEE;
        z-index: 999;
    }

    .awesome-checkbox .checkbox label {
        padding-left: 12px;
    }

    .awesome-checkbox .checkbox label::before {
        height: 25px;
        width: 25px;
    }

    .awesome-checkbox .checkbox label::after {
        height: 25px !important;
        width: 25px !important;
        font-size: 18px;
        padding-left: 4px;
    }

    .attendance-list-content {
        flex: 1 1 auto;
        overflow-x: hidden;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start
    }

    .attendance-list-span {
        display: inline-block;
        vertical-align: middle;
        font-size: 13px;
        color: white;
    }

    .attendance-list-button {
        display: inline-block;
        background: #25167a !important;
        border: none;
        margin: 10px;
        padding: 10px 10px;
        text-align: center;
        flex: 0 0 auto;
    }

    .photo-button {
        padding: 10px 17px;
    }

    .key-button {
        margin-right: 10px;
        margin-left: 0px;
    }

    .additional-contexts {
        padding: 10px;
        color: black;
    }

    .additional-contexts a {
        color: black;
        text-decoration: none;
    }

    .dropdown-menu {
        min-width: 180px;
    }

    .dropdown-menu li:hover {
        background: #eee;
        text-decoration: none;
    }

    .attendance-list-header {
        display: flex;
        min-height: 60px;
        max-width: 99%;
    }

    .view-select-btn {
        margin-right: 10px;
        flex: 0 0 auto;
    }

    .click-save {
        flex: 1 1 auto;
        display: inline-block;
        text-align: center;
        padding-top: 10px;
        margin: 12px;
    }

    .last-saved {
        font-size: 12px;
        color: #25167a;
    }
</style>
